import React from "react";
import Banner from "../components/Banner";
import Speakers from "../components/Speakers";
import { SpeakerData23 } from "../data/SpeakerData23";

export default function PageSpeakers23() {
  return (
    <>
      <Banner className="bg-white-after" altBG="/img/bg-past-speakers.webp">
        <div className="col-12 mb-3">
          <div className="display-1 color-white">Past Speakers</div>
        </div>
        <div className="col-12 col-md-9 col-lg-8 col-xl-7 mb-2">
          <p className="color-white mb-5">
            Want to preview the value FinComp delivers? Browse past sessions to
            see how top industry leaders tackle the most pressing compensation
            challenges in your industry.
          </p>
        </div>

        <div className="col-12">
          <a
            href="https://www.youtube.com/watch?v=uoo0aUihAjg&list=PL6Ss2wtgEhSqi5LfZghQtUnaJlLBH1tZj"
            target="_blank"
            rel="noreferrer"
            className="btn-purple-with-icon"
          >
            Watch Past Sessions
            <i className="fa fa-arrow-right" aria-hidden="true"></i>
          </a>
        </div>
      </Banner>

      <section className="pb-0">
        <div className="row">
          <div className="col-12 text-center">
            <h1 className="color-purple">2023 Speakers</h1>
            <p>
              Sept 17-20, 2023 • Kansas City, MO •{" "}
              <a href="https://fincomp.balancedcomp.com/2023/agenda.html">
                View full agenda
              </a>
            </p>
          </div>
        </div>
      </section>

      <Speakers speakers={SpeakerData23} noModal />
    </>
  );
}
